import classnames from 'classnames';
import { PropsWithChildren } from 'react';

import style from './index.module.css';

interface Props {
  noPadding?: boolean;
}

/**
 * Component that can be used with HeroPage to place additional content on the left side of the page's content.
 *
 * @param children the content.
 * @param noPadding option to remove the default padding provided by the component.
 */
export default function HeroMenu({ children, noPadding = false }: PropsWithChildren<Props>) {
  return (
    <div className={style['Menu']}>
      <div
        className={classnames({
          [style['MenuContent']!]: true,
          [style['Padding']!]: !noPadding,
        })}
      >
        {children}
      </div>
    </div>
  );
}
